import styled from 'styled-components'
import { PROGRESS_AREA_HEIGHT } from '~/app/components/Header'
import {
  ANATOMY_COMPACT,
  anatomyCompact,
} from '~/pages/anatomy/libs/responsive'
import {
  anatomyBodyCss,
  anatomyH1Css,
  anatomyRootCss,
  anatomyStickyButtonCss,
} from '~/pages/anatomy/libs/styles'
import { Button } from '~/shared/components/Button'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

export const InfoPageStyles = {
  Root: styled.div`
    ${anatomyRootCss}
  `,

  StyledContainer: styled(Container)`
    padding: 24px 16px;
    margin-top: ${PROGRESS_AREA_HEIGHT}px;
    height: calc(100% - ${PROGRESS_AREA_HEIGHT}px);

    ${anatomyCompact} {
      overflow-y: auto;
    }
  `,

  ImagePlaceholder: styled.div`
    width: 100%;
    height: 264px;
    background-color: ${COLORS.GRAY_400};
  `,

  ImageWrapper: styled.div`
    max-width: 100%;
    border-radius: 0 0 16px 16px;

    picture {
      display: block;
      width: 100%;
    }

    img {
      max-width: 100%;
      width: 100%;
      display: block;
    }
  `,

  Title: styled.h1`
    ${anatomyH1Css}
    margin-top: 16px;
    margin-bottom: 16px;

    ${anatomyCompact} {
      font-size: ${ANATOMY_COMPACT.fontSize.f22};
      line-height: ${ANATOMY_COMPACT.lineHeight.lh28};
    }
  `,

  Subtitle: styled.p`
    ${anatomyBodyCss}
    text-align: justify;
    margin-bottom: 16px;
  `,

  StyledButton: styled(Button)`
    ${anatomyStickyButtonCss}
  `,
} as const
